import { store } from "@/store/store";
import { ui_log_entry } from "@/shared/dtos/logs/ui_log_entry";
import { ui_logs_query_request } from "@/shared/dtos/logs/ui_logs_query_request";
import { ui_logs_stats } from "@/shared/dtos/logs/ui_logs_stats";

import {
    VuexModule,
    Mutation,
    getModule,
    Module,
    Action
} from "vuex-module-decorators";

import { ssmHttpService } from "@/shared/services/http-service";
// Asumiendo que tienes un archivo de constantes de API, si no, pon la URL string directa
import { API } from "@/shared/api";

@Module({
    namespaced: true,
    name: "ui_logsModule",
    store,
    dynamic: true
})
class ui_logsModule extends VuexModule {
    public logs: ui_log_entry[] = [];
    public stats: ui_logs_stats = new ui_logs_stats();

    // ---------- ACTIONS ----------

    @Action({ commit: "onSetlogs" })
    public async getui_logs_last(take: number) {
        const t = take || 200;
        // Si no tienes API constant, cambia API.ui_logs por "/api/ui-logs"
        return await ssmHttpService.get(`${API.ui_logs}/last?take=${t}`);
    }

    @Action({ commit: "onSetlogs" })
    public async queryui_logs(req: ui_logs_query_request) {
        const r = req || new ui_logs_query_request();

        // Construcción segura de Query String
        const params = new URLSearchParams();
        params.append("take", String(r.take));

        if (r.fromUtc) params.append("fromUtc", r.fromUtc);
        if (r.toUtc) params.append("toUtc", r.toUtc);
        if (r.level && r.level !== 'Todos') params.append("level", r.level);
        if (r.contains) params.append("contains", r.contains);

        return await ssmHttpService.get(`${API.ui_logs}/query?${params.toString()}`);
    }

    @Action
    public async clearui_logs() {
        const res = await ssmHttpService.post(`${API.ui_logs}/clear`, {});
        this.context.commit("onClearlogs");
        return res;
    }

    // ---------- MUTATIONS ----------

    @Mutation
    public onSetlogs(res: any[]) {
        // Mapeo seguro de JSON a DTO
        this.logs = res && Array.isArray(res) ? res.map((x) => new ui_log_entry(x)) : [];

        // Cálculo de estadísticas dentro de la mutación para reactividad inmediata
        const s = new ui_logs_stats();
        for (const item of this.logs) {
            if (!item.level) continue;
            if (item.level === "Error" || item.level === "Critical") s.errors++;
            else if (item.level === "Warning") s.warnings++;
        }
        this.stats = s;
    }

    @Mutation
    public onClearlogs() {
        this.logs = [];
        this.stats = new ui_logs_stats();
    }
}

export default getModule(ui_logsModule);